<i18n lang="yaml" locale="en">
  name: Name
  example: The quick brown fox jumps over the lazy dog.
</i18n>

<i18n lang="yaml" locale="de">
  name: Name
  example: Franz jagt im komplett verwahrlosten Taxi quer durch Bayern.
</i18n>

<template>
  <div
    class="font-file"
    :class="{'asset-browser-item': !isInProject}"
  >
    <template v-if="!isInPropEditor">
      <file
        ref="placeholder"
        class="content"
        :size="'s'"
      />
      <div
        class="name"
      >
        {{ name }}
      </div>
      <keep-alive>
        <FileEditor v-if="$editMode && !isInPropEditor" />
      </keep-alive>
    </template>
    <template v-else>
      <div
        class="font-name"
        :style="fontStyle"
      >
        {{ $t('example') }}
      </div>
    </template>
  </div>
</template>

<script>
import File from '@/components/icons/File'
import FileEditor from '@/components/editor/FileEditor'
import BaseModule from '@/components/modules/BaseModule'
import translatable from '@/store/mixins/translatable'
import fontHandler from '@/mixins/fontHandler'

export default {
  // eslint-disable-next-line vue/name-property-casing
  name: 'font',
  inheritAttrs: false,
  extends: BaseModule,
  customStore: translatable,
  mixins: [fontHandler([
    'src'
  ])],
  components: {
    File,
    FileEditor
  },
  data () {
    return {
      font: undefined
    }
  },
  props: {
    isInPropEditor: {
      type: Boolean,
      default: false
    },
    src: {
      type: String,
      required: true
    },
    name: {
      type: String,
      default: '',
      input: 'text',
      label: 'name',
      condition: (values, path) => path.startsWith('/assets/')
    }
  },
  computed: {
    isInProject () {
      return !this.$store.getters.path.startsWith('/assets/')
    },
    fontStyle () {
      return {
        ...this.fontStyles.src
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.font-file {
  position: relative;
  overflow: hidden;

  .fileName {
    margin-top: 20px;
    display: block;
  }
}
</style>
